import classNames from 'classnames'

type PropertyCardSkeletonProps = {
  className?: string
  variant?: 'grid' | 'list'
}

const PropertyCardSkeleton = ({
  className,
  variant = 'grid',
}: PropertyCardSkeletonProps) => {
  if (variant === 'list') {
    return (
      <div
        className={classNames(
          'flex w-full animate-pulse overflow-hidden rounded-2xl border border-gray-200 bg-white',
          className
        )}
        aria-hidden
      >
        <div className="h-44 w-40 shrink-0 bg-gray-200 sm:h-48 sm:w-44" />
        <div className="flex flex-1 flex-col gap-3 p-4">
          <div className="flex justify-between gap-4">
            <div className="h-7 w-36 rounded bg-gray-200" />
            <div className="h-6 w-12 rounded bg-gray-200" />
          </div>
          <div className="h-4 w-44 rounded bg-gray-200" />
          <div className="h-4 w-3/4 rounded bg-gray-200" />
          <div className="h-3 w-1/2 rounded bg-gray-200" />
        </div>
      </div>
    )
  }

  return (
    <div
      className={classNames(
        'flex h-full min-h-0 w-full animate-pulse flex-col overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm',
        className
      )}
      aria-hidden
    >
      <div className="h-52 bg-gray-200 md:h-56" />
      <div className="flex flex-1 flex-col gap-3 px-4 py-3">
        <div className="flex justify-between gap-4">
          <div className="h-7 w-40 rounded bg-gray-200" />
          <div className="h-6 w-12 rounded bg-gray-200" />
        </div>
        <div className="h-4 w-48 rounded bg-gray-200" />
        <div className="h-4 w-3/4 rounded bg-gray-200" />
        <div className="h-3 w-2/3 rounded bg-gray-200" />
      </div>
    </div>
  )
}

export default PropertyCardSkeleton
